import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchTodos from "../redux/todos/thunk/fetchTodos";
import CompleteTodo from "./CompleteTodo";

const CompletedTodoList = () => {
  const todos = useSelector((state) => state.todos);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTodos);
  }, [dispatch]);

  return (
    <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
      {todos
        .filter((todo) => todo.completed)
        .map((todo) => (
          <CompleteTodo todo={todo} key={todo.id} />
        ))}
    </div>
  );
};

export default CompletedTodoList;
